<script>
	const model = require('model/model');

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const SL_ADMIN_CLICK = analyticsUtilities.events.SL_ADMIN_CLICK;
	const SL_TOGGLE = analyticsUtilities.events.SL_TOGGLE;
	const SL_ASSIGNMENTS_TOGGLE = analyticsUtilities.events.SL_ASSIGNMENTS_TOGGLE;
	const SL_PREVIEW_OPEN = analyticsUtilities.events.SL_PREVIEW_OPEN;

	module.exports = {
		components: {
			'input-item-with-label': require('components/input-item-with-label.vue').default,
			'sign-up-icon': require('components/svg/sign-up-icon.vue').default
		},
		props: ['assignmentSettings', 'updateAssignmentSettings', 'clazz'],
		modelData: ['classCode'],
		computed: {
			libraryRadio() {
				let assignmentSettings = this.assignmentSettings;
				let name = 'library';
				return [
					{
						name,
						text: 'Library access enabled',
						value: true,
						selected: !!assignmentSettings.library
					},
					{
						name,
						text: 'Library access disabled',
						value: false,
						selected: !assignmentSettings.library
					}
				];
			},
			assignmentHideRadio() {
				let assignmentSettings = this.assignmentSettings;
				let name = 'assignmentHideLibrary';
				return [
					{
						name,
						text: 'Allow passages assigned to students to also appear in the Student Library',
						value: false,
						disabled: !assignmentSettings.library,
						selected: !assignmentSettings.assignmentHideLibrary
					},
					{
						name,
						text: 'Automatically hide passages assigned to students',
						value: true,
						disabled: !assignmentSettings.library,
						selected: assignmentSettings.assignmentHideLibrary
					}
				];
			}
		},
		methods: {
			onRadioClick(item) {
				let eventMap = {
					library: SL_TOGGLE,
					assignmentHideLibrary: SL_ASSIGNMENTS_TOGGLE
				};
				let eventName = eventMap[item.name];

				if (eventName) {
					fireEvent(eventName, {
						toggle: item.value,
						cc: this.classCode
					});
				}

				this.updateAssignmentSettings({
					[item.name]: item.value
				});
			},
			onPreviewClick() {
				fireEvent(SL_PREVIEW_OPEN, {
					cc: this.classCode
				});
				model.set('activeClass', this.clazz);
			}
		},
		mounted() {
			fireEvent(SL_ADMIN_CLICK, {
				cc: this.classCode
			});
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.class-library-settings {
		display: block;

		.library-setting {
			border-bottom: 1px solid $c-grey;
			margin-right: 2rem;
			padding-bottom: 2rem;
		}

		.library-settings-sidebar {
			flex-basis: 40%;
			padding: 1rem;

			.library-promo {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				background: linear-gradient(132deg, #fff 49%, #fff 50%, $c-grey-extra-light 51%, $c-grey-extra-light 100%);
				text-align: center;
				padding: 1rem;
				border: 1px solid $c-grey;
				border-radius: 7px;

				ul {
					text-align: left;
				}

				svg {
					height: 10rem;
				}

				h3 {
					margin-bottom: 0;
				}

				.sl-prom-body {
					max-width: 100%;
				}
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.class-library-settings {
			display: flex;
		}
	}
</style>
<template>
	<div class="class-library-settings">
		<div>
			<div class="library-setting">
				<h2>Allow access to the Student Library for this class</h2>
				<p>You may change library access for your class at any time.</p>
				<input-item-with-label
					v-for="item in libraryRadio"
					class="library-option"
					type="radio"
					:key="item.id"
					:name="item.name"
					:item="item"
					:on-item-click="onRadioClick">
				</input-item-with-label>
			</div>
			<div :class="{ 'library-setting': true, disabled: !assignmentSettings.library }">
				<h2>Automatically hide passages assigned to students</h2>
				<p>
					Enable this feature to automatically hide from the Student Library any reading passages you assign to your class. This will apply to reading
					passages you assign from now on.
				</p>
				<input-item-with-label
					v-for="item in assignmentHideRadio"
					class="library-option"
					type="radio"
					:key="item.id"
					:name="item.name"
					:item="item"
					:on-item-click="onRadioClick">
				</input-item-with-label>
			</div>
		</div>
		<div class="library-settings-sidebar">
			<div class="library-promo">
				<sign-up-icon></sign-up-icon>
				<div class="sl-prom-body">
					<h3>About the Student Library:</h3>
					<ul>
						<li>Students choose from 1000s of passages, suggested based on their specific interests.</li>
						<li>No assessments—just reading for the joy of learning.</li>
						<li>
							<a :href="`/assignments#!studentId:/assignmentTab:progress/studentProgressTab:reading/classCode:${classCode}/`">Track progress</a> by class or
							by student.
						</li>
						<li><a href="/teacher-guide/student-library.html">Learn how and why</a> to use Student Library.</li>
					</ul>
					<a
						@click="onPreviewClick"
						href="/student-library"
						class="button">
						Preview the Student Library
					</a>
				</div>
			</div>
		</div>
	</div>
</template>
